import { SEO } from "../components/SEO";
import { QuoteCTA } from "../components/CTA";

const STEPS = [
  { num: "01", name: "UNDERSTAND", text: "Understand the customer's storage requirement." },
  { num: "02", name: "ASSESS & PLAN", text: "Review available space, dimensions and operational requirements." },
  { num: "03", name: "DESIGN", text: "Develop a suitable storage configuration and layout." },
  { num: "04", name: "SUPPLY", text: "Supply the required storage system and accessories." },
  { num: "05", name: "INSTALL", text: "Complete professional installation." },
];

export default function About() {
  return (
    <>
      <SEO title="About Us | Your Storage. Our Solution. — CustoRacks"
        description="CustoRacks provides customised storage solutions for warehouses, industrial facilities and commercial storage — racking, shelving, mezzanine systems, storage pallets and rack safety accessories." />
      <section className="page-hero" data-testid="about-hero">
        <div className="container">
          <div className="crumbs">Home / About Us</div>
          <h1>Your Storage. Our Solution.</h1>
          <p>A storage solution provider — not simply a seller of racks.</p>
        </div>
      </section>
      <section className="section">
        <div className="container about-split">
          <img src="/assets/products/pallet-racking.jpg" alt="CustoRacks storage system installation" loading="lazy" />
          <div>
            <span className="sec-label">About CustoRacks</span>
            <h2>Customised Storage Solutions</h2>
            <p>CustoRacks provides customised storage solutions for warehouses, industrial facilities and commercial storage requirements.</p>
            <p>Our range includes racking systems, shelving systems, mezzanine solutions, storage pallets and rack safety accessories, supported by layout planning, supply and installation services.</p>
            <p>Our approach is simple: understand the requirement, plan the right solution and deliver it professionally.</p>
          </div>
        </div>
      </section>
      <section className="section section-grey" data-testid="process-section">
        <div className="container">
          <div className="section-head">
            <span className="sec-label">How We Work</span>
            <h2>A Simple, Practical Process</h2>
          </div>
          <div className="process">
            {STEPS.map((s) => (
              <div className="process-step" key={s.num} data-testid={`process-${s.name.toLowerCase()}`}>
                <span className="step-num">{s.num}</span>
                <h3>{s.name}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <QuoteCTA />
    </>
  );
}
